const APP_ROUTES = {
    homePage: '/',
    reports: '/report',
    login: '/login',
};

export default APP_ROUTES;

